import { render, staticRenderFns } from "./ClientEventProcedureItem.vue?vue&type=template&id=55de287d&scoped=true"
import script from "./ClientEventProcedureItem.vue?vue&type=script&lang=js"
export * from "./ClientEventProcedureItem.vue?vue&type=script&lang=js"
import style0 from "./ClientEventProcedureItem.vue?vue&type=style&index=0&id=55de287d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de287d",
  null
  
)

export default component.exports